<template>
  <div class="midia-texto-vertical-container d-flex">
    <div class="wrapper-card bg-default">
      <img
        v-if="midiaType === 'image'"
        :src="midiaUrl"
        :style="midiaStyle"
        class="media-image"
      />
      <video
        v-else-if="midiaType === 'video'"
        autoplay
        :key="midiaUrl"
        :style="midiaStyle"
        class="media-video"
      >
        <source :src="midiaUrl" />
      </video>
    </div>
    <div class="text-wrapper-card bg-default d-flex flex-column align-self-end" :style="textContainerStyle">
      <div class="header-wrapper">
        <header
          v-if="showHeader"
          class="d-flex flex-wrap-1 px-2"
        >
          <div class="d-flex align-center">
            <span
              class="text-uppercase ml-2 user-name text-h5"
              style="font-size: 1rem; font-weight: 500; text-transform: none !important;"
            >
              {{ headerText }}<template v-if="complemento"> - {{ complemento }}</template>
            </span>
          </div>
        </header>
      </div>
      <div
        v-html="text"
        class="px-3 py-3 font-weight-normal d-flex align-center align-self-center text-content bg-secondary"
        :style="textStyle"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MidiaTextoVerticalView',
  props: {
    headerText: {
      type: String,
      default: '',
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    complemento: {
      type: String,
      default: '',
    },
    midiaType: {
      type: String,
      required: true,
      validator: (value) => ['image', 'video'].includes(value),
    },
    midiaUrl: {
      type: String,
      required: true,
    },
    midiaStyle: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    textStyle: {
      type: Object,
      default: () => ({}),
    },
    textContainerStyle: {
      type: String,
      default: '',
    },
    colors: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    backgroundColor() {
      return this.colors.backgroundColor || '#ED4619';
    },
    backgroundColorEnd() {
      return this.colors.backgroundColorEnd || '#2C172C';
    },
    backgroundGradient() {
      return `linear-gradient(to bottom, ${this.backgroundColor}, ${this.backgroundColorEnd})`;
    },
    secondaryColor() {
      return this.colors.secondaryColor || '#DDDCDC';
    },
    textColor() {
      return this.colors.textColor || '#4C1D23';
    },
  },
};
</script>

<style lang="scss" scoped>
.midia-texto-vertical-container {
  width: 100%;
  overflow: hidden;
}

.wrapper-card {
  padding: 15px 5px 5px 5px;
  border-radius: 20px 20px 0 0;
  box-shadow: inset 0 40px 10px -25px v-bind(backgroundColor);
  overflow: hidden;
}

.text-wrapper-card {
  width: 100%;
  padding: 5px;
  border-radius: 10px 10px 0 0;
  box-shadow: inset 0 40px 10px -25px v-bind(backgroundColor);
  overflow: hidden;
  box-sizing: border-box;
}

.header-wrapper {
  width: 100%;
  border-radius: 10px 10px 0 0;
}

.bg-default {
  background: v-bind(backgroundGradient);
}

.bg-secondary {
  background-color: v-bind(secondaryColor);
}

.user-name {
  text-transform: none !important;
  font-family: 'ZuumeEdge', sans-serif !important;
  font-style: italic !important;
  font-weight: bold !important;
  text-shadow: 0 1.5px 0 rgba(0, 0, 0, 0.3);
  color: v-bind(secondaryColor);
}

.text-content {
  color: v-bind(textColor);
  font-family: 'Globotipo', sans-serif;
  font-style: normal;
  font-weight: bold;
  word-break: break-word;
  width: 100%;
  box-sizing: border-box;
}

.media-image,
.media-video {
  justify-self: center;
  object-fit: contain;
  border-radius: 10px;
}

header {
  width: 100%;
  background-color: transparent;
}
</style>
